import { useContext } from 'react';
import { MediaPlayerStateContext } from '../context/media-player-context';

export const useAudioRef = () => {
  const { audioRef } = useContext(MediaPlayerStateContext);
  
  return audioRef;
}